<template>
  <div class="decision-option" :class="{ 'decision-option--selected': selected }">
    <v-radio :value="value" :disabled="disabled" density="comfortable">
      <template #label>
        <span class="decision-option__label">
          <span class="decision-option__title">{{ title }}</span>
          <span class="decision-option__meta">{{ meta }}</span>
          <span v-if="note" class="decision-option__note">{{ note }}</span>
          <span v-if="selected && warning" class="decision-option__warning">
            <v-icon size="14" icon="mdi-alert-outline" />
            {{ warning }}
          </span>
        </span>
      </template>
    </v-radio>
  </div>
</template>

<script setup>
defineProps({
  value: { type: [String, Number], required: true },
  title: { type: String, required: true },
  meta: { type: String, default: "" },
  note: { type: String, default: "" },
  warning: { type: String, default: "" },
  selected: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.decision-option {
  border: 1px solid rgb(var(--v-theme-darker-snow));
  border-radius: 12px;
  padding: 4px 12px;
  margin-bottom: 8px;

  &--selected {
    border-color: rgb(var(--v-theme-primary));
    background-color: rgb(var(--v-theme-snow));
  }

  :deep(.v-label) {
    width: 100%;
    opacity: 1;
  }
}

.decision-option__label {
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 2px;
  width: 100%;
  padding: 6px 0;
}

.decision-option__title {
  grid-column: 1;
  color: rgb(var(--v-theme-on-surface));
}

.decision-option__meta {
  grid-column: 2;
  text-align: right;
  color: rgb(var(--v-theme-blue-gray));
  font-size: 14px;
}

.decision-option__note {
  grid-column: 1 / -1;
  color: rgb(var(--v-theme-blue-gray));
  font-size: 14px;
}

.decision-option__warning {
  grid-column: 1 / -1;
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 8px;
  background-color: rgba(var(--v-theme-warning), 0.12);
  color: rgb(var(--v-theme-on-surface));
  font-size: 14px;
}
</style>
